import { registerPageInit } from '../barba/page-init-registry';
import { initActivityPageBreadcrumb } from '../utils/activity-page-breadcrumb';
import { initShareButtons } from '../utils/share-buttons';
import '../../css/_root.scss';
import '../../css/pages/news/index.scss';

function initNewsDetailPage(): void {
  initActivityPageBreadcrumb();
  initShareButtons();
}

registerPageInit('news-detail', initNewsDetailPage);
registerPageInit('news-page', initNewsDetailPage);
